const CENTRIFUGE_ID = 'FOX_CENTRIFUGE_ID';

export function setSocketId(token: string) {
  localStorage.setItem(CENTRIFUGE_ID, token);
}
export function getSocketId(): string | null {
  return localStorage.getItem(CENTRIFUGE_ID);
}
